let currentCustomerData = null;
let isFollowing = false;

// Follow functionality
function followUser() {
  const followBtn = document.querySelector(".follow-btn");
  if (isFollowing) {
    isFollowing = false;
    followBtn.textContent = "Follow";
    followBtn.classList.remove("following");
    // console.log('Unfollowed user');
  } else {
    isFollowing = true;
    followBtn.textContent = "Following";
    followBtn.classList.add("following");
    // console.log('Followed user');
  }
}

// Share functionality
function shareProfile() {
  if (navigator.share) {
    navigator.share({
      title: "Barrel Master Profile",
      text: "Check out this Barrel Master profile!",
      url: window.location.href,
    });
  } else {
    // Fallback: copy to clipboard
    navigator.clipboard.writeText(window.location.href).then(() => {
      alert("Profile link copied to clipboard!");
    });
  }
}

// Carousel navigation
function scrollCarousel(direction) {
  const carousel = document.querySelector(".recommendations-carousel");
  if (!carousel) return;

  const cardWidth = 320; // Width of each card including gap
  const containerWidth = carousel.clientWidth;
  const cardsPerView = Math.max(1, Math.floor(containerWidth / cardWidth));
  const scrollAmount = cardWidth * cardsPerView;

  const currentScroll = carousel.scrollLeft;
  const maxScroll = carousel.scrollWidth - carousel.clientWidth;

  if (direction === "next") {
    const newScroll = Math.min(currentScroll + scrollAmount, maxScroll);
    carousel.scrollTo({
      left: newScroll,
      behavior: "smooth",
    });
  } else {
    const newScroll = Math.max(currentScroll - scrollAmount, 0);
    carousel.scrollTo({
      left: newScroll,
      behavior: "smooth",
    });
  }

  // Update active dot after scrolling
  setTimeout(() => updateActiveDot(), 300);
}

// Update active dot based on scroll position
function updateActiveDot() {
  const carousel = document.querySelector(".recommendations-carousel");
  const dots = document.querySelectorAll(".nav-dot");

  if (!carousel || dots.length === 0) return;

  const cardWidth = 320;
  const containerWidth = carousel.clientWidth;
  const cardsPerView = Math.max(1, Math.floor(containerWidth / cardWidth));
  const currentPosition = carousel.scrollLeft;
  const maxScroll = carousel.scrollWidth - carousel.clientWidth;

  // Check if we're at the end
  if (currentPosition >= maxScroll - 10) {
    // We're at the end, activate the last dot
    dots.forEach((dot, index) => {
      dot.classList.remove("active");
      if (index === dots.length - 1) {
        dot.classList.add("active");
      }
    });
  } else {
    // Normal calculation for other positions
    const scrollAmount = cardWidth * cardsPerView;
    const activeIndex = Math.floor(currentPosition / scrollAmount);
    const safeIndex = Math.max(0, Math.min(activeIndex, dots.length - 1));

    dots.forEach((dot, index) => {
      dot.classList.remove("active");
      if (index === safeIndex) {
        dot.classList.add("active");
      }
    });
  }

  // Debug logging for PC
  // console.log('PC Debug - Current Position:', currentPosition, 'Max Scroll:', maxScroll, 'Active Index:', activeIndex, 'Safe Index:', safeIndex);
}

// Initialize carousel functionality
function initializeCarousel() {
  const carousel = document.querySelector(".recommendations-carousel");
  if (carousel) {
    // Reset scroll position
    carousel.scrollLeft = 0;

    // Update active dot
    setTimeout(() => updateActiveDot(), 100);

    // Add scroll event listener for real-time updates
    carousel.addEventListener("scroll", () => {
      updateActiveDot();
    });
  }
}

// Function to get URL parameters
function getUrlParameter(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

// Main initialization function
function initializeBarrelMasterCheck() {
  // console.log('🚀 Barrel Master Check Starting...');

  // Force refresh by adding timestamp to API URL
  const timestamp = Date.now();

  // Get customer ID from URL
  const customerId = getUrlParameter("customer_id");
  const currentUrl = window.location.href;

  // console.log('Current URL:', currentUrl);
  // console.log('Customer ID:', customerId);

  // Update debug info
  document.getElementById("current-url").textContent = currentUrl;
  document.getElementById("found-customer-id").textContent =
    customerId || "None found";

  const container = document.querySelector(".barrel-master-check");
  const loadingSection = container.querySelector(".loading-section");
  const resultSection = container.querySelector(".result-section");
  const barrelMasterSection = container.querySelector(".barrel-master-success");
  const regularMemberSection = container.querySelector(".regular-member");
  const errorSection = container.querySelector(".error-section");
  const noCustomerIdSection = container.querySelector(".no-customer-id");

  // Update loading message
  document.getElementById("customer-id-display").textContent =
    // customerId ? `Verifying customer ID: ${customerId}` : 'No customer ID found in URL';
    customerId ? "" : "No customer ID found in URL";

  if (!customerId) {
    // No customer ID provided
    setTimeout(() => {
      loadingSection.style.display = "none";
      resultSection.style.display = "block";
      noCustomerIdSection.style.display = "block";

      document.getElementById("api-url").textContent = "N/A - No customer ID";
    }, 2000);
    return;
  }

  // Build API URL with cache busting
  const apiUrl = `https://primebarrel.onrender.com/apps/profile?customer_id=${customerId}&t=${timestamp}`;
  document.getElementById("api-url").textContent = apiUrl;

  console.log("Calling API:", apiUrl);

  // Profiles that don't exist or aren't a public Barrel Master redirect here.
  const NOT_A_BARREL_MASTER_REDIRECT =
    "https://primebarrel.com/pages/membership-area";

  // Call the API
  fetch(apiUrl)
    .then((response) => {
      // 404 = customer doesn't exist. Send them to the membership area
      // rather than rendering an error or empty profile.
      if (response.status === 404) {
        window.location.replace(NOT_A_BARREL_MASTER_REDIRECT);
        return null;
      }
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      return response.json();
    })
    .then((data) => {
      // The 404 branch above already redirected and returned null.
      if (!data) return;
      // console.log('API Response Data:', data);
      currentCustomerData = data;

      // Not a public Barrel Master? Redirect rather than showing the
      // generic regular-member fallback page.
      if (!data.profile || !data.profile.isBarrelMaster) {
        window.location.replace(NOT_A_BARREL_MASTER_REDIRECT);
        return;
      }

      // Hide loading, show results
      loadingSection.style.display = "none";
      resultSection.style.display = "block";

      if (data.profile && data.profile.isBarrelMaster) {
        // Barrel Master
        barrelMasterSection.style.display = "block";

        // Update profile information
        const customerName = data.profile.name || "Barrel Master";
        document.getElementById("customer-name-display").textContent =
          customerName;
        document.getElementById("customer-name-picks").textContent =
          `${customerName.toUpperCase()}'S RECENT BARREL PICKS:`;
        document.getElementById("customer-name-recommendations").textContent =
          `RECOMMENDED EXPRESSIONS BASED ON ${customerName.toUpperCase()}'S PALATE ALIGNMENT:`;

        // Update bio and quote
        document.getElementById("customer-bio").textContent =
          data.profile.bio ||
          "Passionate whiskey enthusiast with years of experience exploring the finest spirits.";

        // Set quote with bold "Mark Twain"
        const quoteText =
          data.profile.quote ||
          "I would share a dram with Mark Twain, discussing life's subtleties over a smoky Scotch.";
        const quoteWithBold = quoteText.replace(
          /(Mark Twain)/g,
          "<strong>$1</strong>",
        );
        document.getElementById("customer-quote").innerHTML = quoteWithBold;

        // Set cover image banner if available
        const coverBanner = document.querySelector(".cover-image");
        if (coverBanner && data.profile.coverImage) {
          let filename = "";
          try {
            filename = new URL(data.profile.coverImage).pathname
              .split("/")
              .pop();
          } catch (e) {
            filename = data.profile.coverImage.split("?")[0].split("/").pop();
          }
          if (filename) {
            coverBanner.style.backgroundImage = `url(https://primebarrel.com/cdn/shop/files/${filename})`;
            coverBanner.classList.add("active");
            container.classList.add("has-cover-image");
          }
        }

        // Set profile picture if available
        if (data.profile.profilePicture) {
          // console.log('Setting profile picture:', data.profile.profilePicture);
          // console.log('Customer ID:', customerId);

          // Add cache-busting parameter to force refresh
          const separator = data.profile.profilePicture.includes("?")
            ? "&"
            : "?";
          const imageUrl =
            data.profile.profilePicture + separator + "t=" + Date.now();
          // console.log('Image URL with cache busting:', imageUrl);

          // Test if the image URL is accessible
          const img = new Image();
          img.onload = function () {
            // console.log('Profile picture loaded successfully');
            document.getElementById("profile-picture").src = imageUrl;
          };
          img.onerror = function () {
            // console.log('Profile picture failed to load, using default');
            const defaultUrl =
              "https://cdn.shopify.com/s/files/1/0565/2162/1686/files/Generated_Image_December_29_2025_-_12_19PM_430x.jpg?v=1767028785" +
              Date.now();
            document.getElementById("profile-picture").src = defaultUrl;
          };
          img.src = imageUrl;
        } else {
          // Default profile picture - only show if no profile picture from API
          // console.log('No profile picture from API, using default');
          document.getElementById("profile-picture").src =
            "https://cdn.shopify.com/s/files/1/0565/2162/1686/files/Generated_Image_December_29_2025_-_12_19PM_430x.jpg?v=1767028785" +
            Date.now();
        }

        function getInstagramHandleLoose(input) {
          const normalized = /^https?:\/\//i.test(input)
            ? input
            : `https://${input}`;
          const u = new URL(normalized);
          return u.pathname.split("/").filter(Boolean)[0] || null;
        }

        // Set Instagram link
        const instagramLink = document.getElementById("instagram-link");
        if (data.profile.instagram) {
          instagramLink.href = data.profile.instagram;
          instagramLink.style.display = "inline-flex";
          document.getElementById("customer-handle").textContent =
            "@" + getInstagramHandleLoose(data.profile.instagram);
        } else {
          instagramLink.style.display = "none";
          document.getElementById("customer-handle").remove();
        }

        // Add expertise tags from metafields only (no static defaults)
        const expertiseContainer = document.getElementById(
          "expertise-tags-container",
        );
        if (
          data.profile.expertiseTags &&
          data.profile.expertiseTags.length > 0
        ) {
          data.profile.expertiseTags.forEach((tag) => {
            const tagElement = document.createElement("span");
            tagElement.className = "expertise-tag";
            tagElement.textContent = tag;
            expertiseContainer.appendChild(tagElement);
          });
        }
        // No default tags - container will be empty if no expertise tags in metafields

        // Add specialty tags
        const specialtyContainer = document.getElementById(
          "specialty-tags-container",
        );
        if (
          data.profile.specialtyTags &&
          data.profile.specialtyTags.length > 0
        ) {
          data.profile.specialtyTags.forEach((tag) => {
            const tagElement = document.createElement("span");
            tagElement.className = "specialty-tag";
            tagElement.textContent = tag;
            specialtyContainer.appendChild(tagElement);
          });
        }
        // No default tags — an empty profile shows no specialty/expertise pills.

        // The badge SVG lives in theme/assets/barrel_master_age.svg.
        // We can't use Liquid's asset_url helper from a static JS asset, so
        // we read the resolved URL of an existing theme asset and rewrite
        // the filename to point at our SVG.
        const themeAssetSample = document.querySelector(
          'link[rel="stylesheet"][href*="component-profiles.css"]',
        );
        const TENURE_BADGE_SVG_URL = themeAssetSample
          ? themeAssetSample.href.replace(
              /component-profiles\.css(\?.*)?$/,
              "barrel_master_age.svg",
            )
          : "/cdn/shop/files/barrel_master_age.svg";

        // Resolve the tier badge URL using the same theme-slot trick.
        const TIER_BADGE_SVG_URL = themeAssetSample
          ? themeAssetSample.href.replace(
              /component-profiles\.css(\?.*)?$/,
              "prime_barrel_tier.svg",
            )
          : "/cdn/shop/files/prime_barrel_tier.svg";

        // Add badges - tier badge + tenure badge (if ≥1 year) + any awarded badges
        const badgesContainer = document.getElementById("badges-container");
        const tenureYears = data.profile.tenureYears;
        const tierLabel = data.profile.tierLabel;
        const hasTenureBadge =
          typeof tenureYears === "number" && tenureYears >= 1;
        const hasTierBadge = typeof tierLabel === "string" && tierLabel.length;
        const hasOtherBadges =
          data.profile.badges && data.profile.badges.length > 0;

        if (hasTierBadge) {
          const tierWrap = document.createElement("div");
          tierWrap.className = "tier-badge";
          tierWrap.title = `Single Barrel Tier ${tierLabel} Advocate`;
          tierWrap.innerHTML = `
            <img src="${TIER_BADGE_SVG_URL}" alt="Single Barrel Tier ${tierLabel} Advocate">
            <p class="tier-badge-number">${tierLabel}</p>
          `;
          badgesContainer.appendChild(tierWrap);
        }

        if (hasTenureBadge) {
          const tenureWrap = document.createElement("div");
          tenureWrap.className = "tenure-badge";
          tenureWrap.title = `TPB Member ${tenureYears} ${tenureYears === 1 ? "Year" : "Years"}`;
          tenureWrap.innerHTML = `
            <img src="${TENURE_BADGE_SVG_URL}" alt="TPB Member ${tenureYears} ${tenureYears === 1 ? "Year" : "Years"}">
            <p class="tenure-badge-years">${tenureYears}</p>
          `;
          badgesContainer.appendChild(tenureWrap);
        }

        if (hasOtherBadges) {
          data.profile.badges.forEach((badge) => {
            const badgeElement = document.createElement("img");
            badgeElement.className = "badge";
            badgeElement.src = badge;
            badgeElement.alt = "Achievement Badge";
            badgeElement.title = "Achievement Badge";
            badgeElement.onclick = () => {
              console.log("Badge clicked:", badge);
            };
            badgesContainer.appendChild(badgeElement);
          });
        }

        if (!hasTierBadge && !hasTenureBadge && !hasOtherBadges) {
          badgesContainer.style.display = "none";
        }

        // Create palate chart - Show all 10 palate preferences
        const palateChart = document.getElementById("palate-chart");
        if (data.profile.palate) {
          const palateLabels = {
            palate_sweet_vanilla: "SWEET & VANILLA",
            palate_fruity_bright: "FRUITY & BRIGHT",
            palate_spicy_bold: "SPICY & BOLD",
            palate_nutty_chocolatey: "NUTTY & CHOCOLATEY",
            palate_oaky_woody: "OAKY & WOODY",
            palate_smoky_earthy: "SMOKY & EARTHY",
            palate_floral_delicate: "FLORAL & DELICATE",
            palate_tannic_dry: "TANNIC & DRY",
            palate_savory_umami: "SAVORY & UMAMI",
            palate_unique_experimental: "UNIQUE & EXPERIMENTAL",
          };

          // Show only palate preferences with values > 0
          Object.entries(palateLabels).forEach(([key, label]) => {
            const value = data.profile.palate[key] || 0;
            // Only show palate items with values greater than 0
            if (value > 0) {
              const palateItem = document.createElement("div");
              palateItem.className = "palate-item";

              // Create box-style bars (5 boxes total)
              let boxesHTML = "";
              for (let i = 0; i < 5; i++) {
                const isFilled = i < value;
                boxesHTML += `<div class="palate-box${isFilled ? " filled" : ""}"></div>`;
              }

              palateItem.innerHTML = `
                <div class="palate-label">${label}</div>
                <div class="palate-bar">
                  ${boxesHTML}
                </div>
              `;
              palateChart.appendChild(palateItem);
            }
          });
        }

        // Hide the entire PALATE section when the customer has no preferences
        // set — i.e. no bars were rendered (palate missing or all values 0).
        const palateSection = palateChart
          ? palateChart.closest(".palate-section")
          : null;
        if (palateSection && palateChart.children.length === 0) {
          palateSection.style.display = "none";
        }

        // Add recent picks with real data
        const recentPicksContainer = document.getElementById(
          "recent-picks-container",
        );
        if (data.profile.recentPicks && data.profile.recentPicks.length > 0) {
          // Use real recent picks from API
          data.profile.recentPicks.forEach((pick, index) => {
            const pickCard = document.createElement("div");
            pickCard.className = "pick-card";
            pickCard.onclick = () => {
              // Navigate to product page if available
              if (pick.handle) {
                window.open(`/products/${pick.handle}`, "_blank");
              }
            };
            pickCard.innerHTML = `
              <img src="${pick.image || "https://via.placeholder.com/100x100/8B4513/ffffff?text=Whiskey"}" 
                   alt="${pick.title}" class="pick-image">
              <div class="pick-title">${pick.title || "Recent Pick"}</div>
            `;
            recentPicksContainer.appendChild(pickCard);
          });
        } else {
          // No recent picks — hide the entire section
          const recentPicksSection = recentPicksContainer.closest(
            ".recent-picks-section",
          );
          if (recentPicksSection) recentPicksSection.style.display = "none";
        }

        // Add recommendations with real data
        const recommendationsContainer = document.getElementById(
          "recommendations-container",
        );
        if (data.recommended && data.recommended.length > 0) {
          data.recommended.forEach((product, index) => {
            const productCard = document.createElement("div");
            productCard.className = "recommendation-card";
            productCard.onclick = () => {
              // Navigate to product page
              if (product.handle) {
                window.open(`/products/${product.handle}`, "_blank");
              }
            };
            productCard.innerHTML = `
              ${
                product.primaryImage
                  ? `<img src="${product.primaryImage.src}" alt="${product.title}" class="rec-image">`
                  : `<img src="https://via.placeholder.com/100x100/8B4513/ffffff?text=Whiskey" alt="${product.title}" class="rec-image">`
              }
              <div class="rec-title">${product.title}</div>
              <div class="rec-price">$${product.price}</div>
            `;
            recommendationsContainer.appendChild(productCard);
          });

          // Add navigation dots
          const navDots = document.getElementById("nav-dots");
          const cardWidth = 320; // Width of each card including gap
          const containerWidth = recommendationsContainer.clientWidth;
          const cardsPerView = Math.max(
            1,
            Math.floor(containerWidth / cardWidth),
          );
          const dotCount = Math.ceil(data.recommended.length / cardsPerView);

          // Debug logging for PC
          // console.log('PC Debug - Container Width:', containerWidth, 'Cards Per View:', cardsPerView, 'Dot Count:', dotCount, 'Total Cards:', data.recommended.length);

          // Clear existing dots
          navDots.innerHTML = "";

          for (let i = 0; i < dotCount; i++) {
            const dot = document.createElement("div");
            dot.className = "nav-dot" + (i === 0 ? " active" : "");
            dot.onclick = () => {
              // console.log('PC Debug - Dot clicked:', i, 'of', dotCount);

              // Remove active class from all dots
              document
                .querySelectorAll(".nav-dot")
                .forEach((d) => d.classList.remove("active"));
              // Add active class to clicked dot
              dot.classList.add("active");

              // Calculate scroll position
              let scrollPosition;
              if (i === dotCount - 1) {
                // For the last dot, scroll to the maximum possible position
                const maxScroll =
                  recommendationsContainer.scrollWidth -
                  recommendationsContainer.clientWidth;
                scrollPosition = maxScroll;
                // console.log('PC Debug - Last dot, scrolling to max:', scrollPosition);
              } else {
                // For other dots, use normal calculation
                scrollPosition = i * cardWidth * cardsPerView;
                // console.log('PC Debug - Normal dot, scrolling to:', scrollPosition);
              }

              // Scroll to position
              recommendationsContainer.scrollTo({
                left: scrollPosition,
                behavior: "smooth",
              });
            };
            navDots.appendChild(dot);
          }
        } else {
          // No recommendations — hide the entire section
          const recommendationsSection = recommendationsContainer.closest(
            ".recommendations-section",
          );
          if (recommendationsSection)
            recommendationsSection.style.display = "none";
        }

        // Initialize carousel functionality
        initializeCarousel();
      } else {
        // Regular member
        regularMemberSection.style.display = "block";

        // Update customer info
        document.getElementById("customer-name-regular").textContent =
          data.profile?.name || "Member";
        document.getElementById("customer-level-regular").textContent =
          data.profile?.memberLevel || "Member";
      }
    })
    .catch((error) => {
      console.error("API Error:", error);

      if (window.location.hostname.endsWith(".shopifypreview.com")) {
        const liveProfileUrl = new URL(
          "/pages/profiles",
          "https://primebarrel.com",
        );
        liveProfileUrl.search = window.location.search;
        window.location.replace(liveProfileUrl.toString());
        return;
      }

      // Hide loading, show error
      loadingSection.style.display = "none";
      resultSection.style.display = "block";
      errorSection.style.display = "block";

      document.getElementById("error-message").textContent =
        `Error: ${error.message}`;
    });
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
  initializeBarrelMasterCheck();
});
